import Button from "src/components/MyButton/Button"
import { StyleTabsCustom } from "src/components/TabsCustom/styled"
import TabsCustom from "src/components/TabsCustom"
import ListPurchase from "./component/ListSale"
import { useState } from "react"
import { WrapperStyle } from "src/pages/ADMIN/HumanResource/styled"
import { ToolBarStyle } from "src/pages/ADMIN/HumanResource/Work/Task/styled"
import BtnExportExcel from "src/components/BtnExportExcel"
import ReportService from "src/services/ReportService"
const Index = props => {
  const [filter, setFilter] = useState({})
  const [openModal, setOpenModal] = useState(false)
  const [modalMode, setModalMode] = useState("create")
  const [userData, setUserData] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const [excelKeyword, setExcelKeyword] = useState("")
  return (
    <>
      {" "}
      <div>
        <WrapperStyle>
          <ToolBarStyle>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 4,
                marginBottom: 20,
                flexWrap: "wrap",
                gap: 8,
              }}
              className="px-2 p-md-0"
            >
              <h3
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#005F90",
                  margin: 0,
                }}
              >
                {" "}
                BÁO CÁO PHẦN BÁN
              </h3>
            </div>
            <div className="right-side d-none d-md-flex">
              <BtnExportExcel
                api={ReportService.exportExcelReportAgencySell}
                filter={filter}
                fileName="Báo_cáo_phần_bán"
                buttonText="Xuất Excel"
                keyword={excelKeyword}
              />
            </div>
            <div style={{ width: "100%" }} className="px-2 p-md-0">
              <ListPurchase
                // type={Tabs[key].type}
                scroll={{ x: true }}
                // tabStatus={tabStatus}
                setParentFilter={setFilter}
                filter={filter}
                refresh={refresh}
                setRefresh={setRefresh}
                // permissions={permissions}
                setExcelKeyword={setExcelKeyword}
              />
            </div>
          </ToolBarStyle>
        </WrapperStyle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 16,
            flexWrap: "wrap",
            gap: 12,
            position: "relative",
          }}
        ></div>
      </div>
    </>
  )
}
export default Index
